import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["tab", "section"]
  }

  changeTab(event) {
    let value = event.currentTarget.dataset.value

    this.tabTargets.forEach(tab => {
      if (tab.dataset.value === value) {
        tab.setAttribute("aria-selected", "true")
      } else {
        tab.setAttribute("aria-selected", "false")
      }
    })

    this.sectionTargets.forEach(section => {
      if (section.dataset.value === value) {
        section.classList.remove("d-none")
      } else {
        section.classList.add("d-none")
      }
    })
  }
}
